import { TextField, useTheme } from '@mui/material'
import { IFlow, INode, NodeType } from '../../../definitions/Nodes'
import { IDryRunSettingsData } from '../../../definitions/NodesDescription'
import NodeManager from '../../../managers/NodeManager'

interface P {
    setSelected: (node: INode) => void
    selectedNode: INode<NodeType>
    flow: IFlow
    disable: boolean
}

function NodeDryRunConfigEditor({ selectedNode, setSelected, disable }: P) {
    const theme = useTheme()
    const description = NodeManager.getDescription(selectedNode.type)
    const dryRunConfig = description.dryRunConfig?.map(x => x) ?? []

    const choiceEditor = (data: IDryRunSettingsData<NodeType>) => {
        switch (data.type) {
            case 'js': return null
            case 'sql': return null
            case 'json': return null
            case 'select': return null
            case 'multi-select': return null
            case 'boolean': return null
            case 'custom': return null
            case 'multiline':
            case 'number':
            case 'string':
            default: {
                if (!selectedNode.dryRunConfig)
                    selectedNode.dryRunConfig = {}
                const value = selectedNode.dryRunConfig[data.parameter]

                return (
                    <div>
                        <TextField
                            disabled={disable}
                            label={data.parameter}
                            minRows={data.type === 'multiline' ? 5 : 1}
                            maxRows={data.type === 'multiline' ? 10 : 5}
                            type={data.type === 'number' ? 'number' : undefined}
                            value={value}
                            fullWidth
                            multiline={data.type !== 'number'}
                            onChange={e => {
                                const newValue = e.target.value
                                setSelected({ ...selectedNode, dryRunConfig: { ...selectedNode.dryRunConfig, [data.parameter]: newValue } })
                            }}
                        />
                    </div>
                )
            }
        }
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'calc(var(--unit) * 3)', height: '100%', flex: 1 }}>
            {dryRunConfig.map((data, index) => {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', flex: 0, marginTop: theme.spacing(1) }} key={'node-editor-' + index}>
                        {choiceEditor(data)}
                    </div>
                )
            })}
        </div>
    )
}

export default NodeDryRunConfigEditor
